// extracted by css-extract-rspack-plugin
export default {"input":"create-event-modal__input___nDkSc common__textInput___S5Sur common__sansSerif___TyY0C","inner":"create-event-modal__inner___XIRH7"};